import { FC, useEffect, useState } from 'react';
import { track } from '../tracking';
import { ClinicCheck } from './toolDiagnosis/ClinicCheck';
import { InternetCheck } from './toolDiagnosis/InternetCheck';
import { PDFPreviewCheck } from './toolDiagnosis/PDFPreviewCheck';
import PtCountCheck from './toolDiagnosis/PtCountCheck';
import RxPushFailedCheck from './toolDiagnosis/RxDraftCheck';
import { TimeCheck } from './toolDiagnosis/TimeCheck';

export const TOTAL_CHECKS = 3;

type Props = { onDone?: () => void };

export const WithAppDiagnosis: FC<Props> = ({ children, onDone }) => {
    const [checks, setChecks] = useState<{
        [k: string]: { [key: string]: string };
    }>({});
    let trackingObj = {};

    useEffect(() => {
        if (Object.entries(checks).length === TOTAL_CHECKS) {
            onDone && onDone();
            Object.entries(checks).forEach(([k, v]) => {
                trackingObj = {
                    ...trackingObj,
                    [k]: JSON.stringify(v),
                };
            });
            track('DOC_DIAGNOSIS', trackingObj);
        }
    }, [Object.entries(checks).length]);

    const onSuccessfulCheck = (obj: { [k: string]: string }) => {
        setChecks((checks) => ({ ...checks, [obj.name]: { ...obj } }));
    };

    const onFailure = (obj: { [k: string]: string }) => {
        setChecks((checks) => ({ ...checks, [obj.name]: { ...obj } }));
    };

    return (
        <div className="h-full w-full flex flex-col">
            <InternetCheck onSuccess={onSuccessfulCheck} onFailure={onFailure}>
                <TimeCheck onSuccess={onSuccessfulCheck} onFailure={onFailure}>
                    <ClinicCheck onSuccess={onSuccessfulCheck} onFailure={onFailure}>
                        {/* <PDFPreviewCheck onSuccess={onSuccessfulCheck} onFailure={onFailure}> */}
                        <RxPushFailedCheck onSuccess={onSuccessfulCheck} onFailure={onFailure}>
                            <PtCountCheck onSuccess={onSuccessfulCheck} onFailure={onFailure}>
                                {children}
                            </PtCountCheck>
                        </RxPushFailedCheck>
                        {/* </PDFPreviewCheck> */}
                    </ClinicCheck>
                </TimeCheck>
            </InternetCheck>
        </div>
    );
};
